import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import LaddaButton, { SLIDE_DOWN } from 'react-ladda';
import { useTranslation } from 'react-i18next';

import { translateError } from '../utils/translateError';
import { cancelBooking } from '../state/actions/service';

import '../styles/success.scss';

function CancelBooking() {
  const { t } = useTranslation();
  const loading = useSelector((state) => state.service.loading);
  const error = useSelector((state) => state.service.error);
  const success = useSelector((state) => state.service.success);
  const dispatch = useDispatch();

  const { token, slug } = useParams();

  // useEffect(() => {
  //   if (token) {
  //     dispatch(cancelBooking(token));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [token]);

  return (
    <div className="container success-container text-center">
      {!loading && !success && !error && token && (
        <div>
          <h1>{t('cancel_booking_title', 'Cancel Booking')}</h1>
          <p>{t('cancel_booking_prompt', 'Are you sure you want to cancel this booking?')}</p>
          <LaddaButton
            disabled={loading}
            data-style={SLIDE_DOWN}
            className="btn btn-lg btn-primary mr-2"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            {t('cancel_booking_keep', 'No, keep it')}
          </LaddaButton>
          <LaddaButton
            disabled={loading}
            data-style={SLIDE_DOWN}
            className="btn btn-lg btn-danger"
            onClick={() => dispatch(cancelBooking(token))}
          >
            {t('cancel_booking_cancel', 'Cancel Booking')}
          </LaddaButton>
        </div>
      )}
      {loading && (
        <div className="spinner-border" role="status">
          <span className="sr-only">{t('loading', 'Loading...')}</span>
        </div>
      )}
      {success && (
        <div>
          <h1>{t('cancel_booking_success', 'Your booking is cancelled')}</h1>
        </div>
      )}
      {error && <p className="text-danger">{translateError(error)}</p>}

      {(success || error) && slug && (
        <div className="event_link">
          <div>
            {t('book_a_new_event_service', 'Book a new service')}
            <div className="text-center">
              <a
                target="_blank"
                rel="noopener noreferrer"
                //DEVhref={`http://localhost:3000/event/${slug}`}
                href={`https://cykelverkstad.mioo.cc/event/${slug}`}
              >
                {t('event_link', 'Go to the event')}
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CancelBooking;
